import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

interface SearchProps {
  activeSearch?: boolean
}

export const TableHeader = styled.div`
  display: flex;
  padding: 0px 0px 24px 0px;
  justify-content: space-between;
  @media ${device.smallScreen} {
    padding: 24px 24px 20px 24px;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  width: ${(props: SearchProps) => (props.activeSearch ? '256px' : '40px')};
  @media ${device.smallScreen} {
    width: 256px;
  }
`

export const StyledInput = styled('input')`
  background: ${colors.errorBg};
  border: 1px solid ${colors.greyStroke};
  box-sizing: border-box;
  border-radius: 20px;
  padding: 0px 16px;
  height: 40px;
  width: 100%;
  outline: none;
  &::placeholder {
    color: transparent;
  }
  &:focus {
    color: ${colors.mainText};
    outline: none;
  }
  @media ${device.smallScreen} {
    &::placeholder {
      color: ${colors.greyTextWhiteBg};
    }
  }
`

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 8px;
  background-color: ${colors.white};
`

export const RoundBtn = styled.button`
  background: ${colors.white};
  border: 1px solid ${colors.mainText};
  box-sizing: border-box;
  border-radius: 24px;
  min-width: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
`
interface Props {
  approvedListLenght: boolean
}

export const BtnWithPlus = styled.button`
  display: grid;
  grid-template-columns: 11px 1fr;
  gap: 10.5px;
  align-items: center;
  font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  outline: none;
  box-sizing: border-box;
  border-radius: 27px;
  height: 40px;
  line-height: 14px;
  border: ${(props: Props) =>
    props.approvedListLenght ? '1px solid #646877' : '1px solid #1cb954'};
  background: ${(props: Props) =>
    props.approvedListLenght ? '#fff' : '#1cb954'};
  cursor: pointer;
  font-size: 14px;
  color: ${(props: Props) => (props.approvedListLenght ? '#1cb954' : '#fff')};
  transition: all 0.2s;
  transition-delay: 0.3s;
  width: auto;
  padding: 9.5px 40px 9.5px 40px;
  min-width: 238px;
  &:hover {
    box-shadow: ${(props: Props) =>
      props.approvedListLenght
        ? '0px 2px 8px rgba(0, 0, 0, 0.15)'
        : '0px 2px 6px rgba(0, 0, 0, 0.2);'};
  }
`
